export default function verification(state={}, action) {
	switch (action.type) {
		case 'INIT_VERIFICATION':
			return {
				...state,
				gateway: undefined,
				current_action: action.data.next_action,
				get_status: 0,
				verify_status: 0
			};
		case 'RESET_CURRENT_VERIFICATION_ACTION':
			return {
				...state,
				sent_count: 0,
				gateway: undefined,
				current_action: null,
			};
		case 'GET_CODE':
			let sent_count = state.sent_count || 0;
			if (action.data.status === 0) {
				sent_count += 1;
			}
			return {
				...state,
				sent_count,
				gateway: action.data.gateway,
				get_status: action.data.status
			};
		case 'VERIFY_CODE':
			return {
				...state,
				verify_status: action.data.status,
			};
		case 'SET_ERR':
			return {
				...state,
				err: action.data.err,
			};
		case 'SET_LOADING':
			return {
				...state,
				loading: action.data.loading,
			};
		case 'SET_TOAST':
			return {
				...state,
				toast: action.data.toast,
			};
			default:
			break;
	}
	return state;
}


// WEBPACK FOOTER //
// ./app/reducers/verification.js